// require('./bootstrap');

$(function() {
    $('.image').lazy();

    $('.mobile-quote-trigger').on('click', function() {
        $('#navbar').collapse('hide');
        $('.popup').removeClass('show');
        $('body').css('overflow', '');
    });
})

require('./slider-before-after');

require('./slick-carousel');

require('./main');
